export enum ComponentState {
    View,
    Add,
    Edit,
    Disabled
}